import { ReactNode } from 'react';

import { Typography } from '@cast/design-system';

type Props = {
  italic?: boolean;
  children: ReactNode;
};

export function TourStepText(props: Props) {
  const variant = props.italic ? 'P12R' : 'P12M';
  return (
    <Typography
      variant={variant}
      color="#fff"
      fontStyle={props.italic ? 'italic' : 'normal'}
    >
      {props.children}
    </Typography>
  );
}
